import { motion } from "framer-motion";
import { Quotes } from "@phosphor-icons/react";

export default function Founder() {
  return (
    <section
      id="founder"
      className="py-20 md:py-32 bg-[#F8FAFC]"
      data-testid="founder-section"
    >
      <div className="container-pad mx-auto max-w-6xl">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start"
        >
          <div className="lg:col-span-4">
            <p className="text-xs md:text-sm uppercase tracking-[0.2em] font-bold text-[#2A9D8F] mb-5">
              Meet the founder
            </p>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#0F2942] leading-[1.1]" data-testid="founder-heading">
              Juliet Bude.
            </h2>
            <p className="mt-4 text-sm md:text-base uppercase tracking-[0.18em] text-[#475569] font-semibold">
              Founder &amp; Owner
            </p>

            <div className="mt-8 rounded-3xl bg-[#1E5F8C] text-[#F8FAFC] p-7" data-testid="founder-card">
              <Quotes size={32} weight="fill" className="text-[#2A9D8F]" />
              <p className="mt-5 font-serif text-lg leading-snug">
                "Every client is someone's parent, partner, or dearest friend.
                We care for them the way we'd want our own family cared for."
              </p>
              <p className="mt-4 text-xs uppercase tracking-[0.2em] text-[#F8FAFC]/70">
                Juliet Bude
              </p>
            </div>
          </div>

          <div className="lg:col-span-8 lg:pt-2">
            <div className="space-y-5 text-base md:text-lg leading-relaxed text-[#475569]">
              <p>
                Juliet Bude founded Julicare Health Services in 2022 after more
                than fifteen years on the front lines of healthcare. Beginning
                her career in 2007, she has worked across hospital wards,
                community programs, and private home-care settings, supporting
                clients through every stage of life and recovery.
              </p>
              <p>
                Her years at the bedside taught her a quiet truth: clinical
                excellence is only half of care. The other half is presence,
                patience, and the kind of attention that makes a person feel
                truly seen. Julicare is built around that belief.
              </p>
              <p>
                Today, Juliet personally meets with every family before care
                begins. She matches caregivers thoughtfully, reviews each plan
                as needs evolve, and stays just a phone call away. Her standard
                is simple: the care she would want for her own loved ones,
                delivered every single shift.
              </p>
            </div>

            <div className="mt-10 grid sm:grid-cols-3 gap-4">
              <Pillar k="15+ yrs" v="Healthcare experience since 2007" />
              <Pillar k="Hospital, community & private care" v="Cross-setting clinical background" />
              <Pillar k="Family-first" v="Personally meets every new client" />
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}

function Pillar({ k, v }) {
  return (
    <div className="rounded-2xl bg-[#EEF4F8] border border-[#1E5F8C]/10 p-5">
      <p className="font-serif text-lg md:text-xl text-[#0F2942] leading-tight">{k}</p>
      <p className="mt-1.5 text-sm text-[#475569] leading-relaxed">{v}</p>
    </div>
  );
}
